<template>
  <!-- 4993 A3: flex prompt after punch-out / manual add (D-FLEX2-4). Persistent so a
       stray tap never loses the summary; "Decide later" is the only silent exit and
       leaves the engine lines at flex_choice = pending. -->
  <v-dialog :value="value" persistent max-width="420">
    <v-card>
      <v-card-title class="text-subtitle-1">{{ $t('message.flex.overtimeRegistered') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4 pb-2">
        <div class="d-flex justify-space-between body-2 mb-1">
          <span>{{ $t('message.flex.overtime') }}</span>
          <span class="font-weight-medium">{{ hm(totals.overtimeMinutes) }}</span>
        </div>
        <div class="d-flex justify-space-between body-2 mb-1">
          <span>{{ $t('message.flex.toFlexAccount') }}</span>
          <span class="font-weight-medium">{{ hm(totals.flexMinutes) }}</span>
        </div>
        <div class="d-flex justify-space-between body-2">
          <span>{{ $t('message.flex.paidSupplement') }}</span>
          <span class="font-weight-medium">{{ hm(totals.supplementMinutes) }}</span>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="flex-wrap">
        <v-btn color="success" id="flexChoiceFlex" :loading="saving === 'flex'" :disabled="!!saving" @click="choose('flex')">{{ $t('message.flex.sendToFlex') }}</v-btn>
        <v-btn color="primary" id="flexChoicePayout" :loading="saving === 'payout'" :disabled="!!saving" @click="choose('payout')">{{ $t('message.flex.payOut') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn text small id="flexChoiceLater" :disabled="!!saving" @click="later">{{ $t('message.flex.decideLater') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { formatMinutesHM } from '@/utils/flexPrompt.mjs'

export default {
  name: 'FlexChoiceDialog',
  props: {
    value: { type: Boolean, default: false },
    // { lineGroup, overtimeMinutes, flexMinutes, supplementMinutes, lines } —
    // built by summarizePunchOut() (punch-out / manual add) or summarizeLine()
    // ("Decide now" on one existing engine line).
    summary: { type: Object, default: null }
  },
  data () {
    return {
      saving: null // 'flex' | 'payout' while the choice is being posted
    }
  },
  computed: {
    totals () {
      const s = this.summary || {}
      return {
        overtimeMinutes: s.overtimeMinutes || 0,
        flexMinutes: s.flexMinutes || 0,
        supplementMinutes: s.supplementMinutes || 0
      }
    }
  },
  methods: {
    hm (minutes) {
      return formatMinutesHM(minutes)
    },
    close (result) {
      this.$emit('input', false)
      this.$emit('closed', result)
    },
    later () {
      this.$emit('later')
      this.close({ choice: null, saved: false, lines: [] })
    },
    choose (choice) {
      if (this.saving) return
      const lineGroup = this.summary ? this.summary.lineGroup : null
      if (!lineGroup) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.flex.noPendingLines' })
        this.close({ choice, saved: false, lines: [] })
        return
      }
      this.saving = choice
      this.$api.execute('post', '/hours/flex-choice', { line_group: lineGroup, choice })
        .then((response) => {
          const lines = response && response.data && Array.isArray(response.data.lines) ? response.data.lines : []
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'message.flex.choiceSaved' })
          this.$emit('chosen', lines, choice)
          this.close({ choice, saved: true, lines })
        })
        .catch((error) => {
          const status = error && error.response ? error.response.status : null
          const text = status === 404
            ? 'message.flex.noPendingLines'
            : (status === 422 ? 'message.common.validationIssue' : 'message.common.errorOccured')
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text })
          this.close({ choice, saved: false, lines: [] })
        })
        .finally(() => {
          this.saving = null
        })
    }
  }
}
</script>
